(() => {
  const init = (root) => {
    const form = root.querySelector('.prayer-request__form');
    if (!form || form.dataset.prayerReady === 'true') return;
    form.dataset.prayerReady = 'true';

    const fallbackEmail = root.dataset.fallbackEmail || '';
    const nameInput = form.querySelector('[data-prayer-name]');
    const emailInput = form.querySelector('[data-prayer-email]');
    const bodyInput = form.querySelector('[data-prayer-body]');
    const shareInput = form.querySelector('[data-prayer-share]');

    form.addEventListener('submit', () => {
      if (nameInput && !nameInput.value.trim()) {
        nameInput.value = 'Anonymous';
      }

      if (emailInput && !emailInput.value.trim() && fallbackEmail) {
        emailInput.value = fallbackEmail;
      }

      if (bodyInput && shareInput?.checked) {
        const note = shareInput.value || 'OK to share anonymously on the prayer wall';
        const body = bodyInput.value.trim();
        bodyInput.value = body ? `${body}\n\n[${note}]` : `[${note}]`;
      }
    });
  };

  const scan = () => {
    document.querySelectorAll('.prayer-request').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target?.querySelector?.('.prayer-request') || event.target;
    if (section?.classList?.contains('prayer-request')) init(section);
  });
})();
